export default "__VITE_ASSET__BZcpa89m__"